<template>
    <TableLayout :permissions="['business:problems:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="题目名称" prop="title">
                <el-input v-model="searchForm.title" placeholder="请输入" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="人员类型" prop="useType">
                <el-select v-model="searchForm.useType" placeholder="请选择" @keypress.enter.native="search">
                    <el-option label="访客和劳务" value="0"></el-option>
                    <el-option label="仅访客" value="1"></el-option>
                    <el-option label="仅劳务" value="2"></el-option>
                </el-select>
            </el-form-item>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <ul class="toolbar" v-permissions="['business:problems:create']">
                <li><el-button type="primary" @click="$refs.operaProblemsWindow.open('新建试题信息表')" icon="el-icon-plus" v-permissions="['business:problems:create']">新建</el-button></li>
            </ul>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
            >
                <el-table-column prop="title" label="题目名称" min-width="150px"></el-table-column>
                <el-table-column prop="useType" label="适用人员类型" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.useType === 0">访客和劳务</span>
                        <span v-if="row.useType === 1">仅访客</span>
                        <span v-if="row.useType === 2">仅劳务</span>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="题目类型" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.type === 0">判断</span>
                        <span v-if="row.type === 1">单选</span>
                        <span v-if="row.type === 2">多选</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sortnu" label="题目顺序(升序)" min-width="100px"></el-table-column>
                <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
                <el-table-column prop="creatorName" label="创建人" min-width="100px"></el-table-column>
                <el-table-column
                    v-if="containPermissions(['business:company:update', 'business:company:delete'])"
                    label="操作"
                    min-width="120"
                    fixed="right"
                >
                    <template slot-scope="{row}">
                        <el-button type="text" @click="edit(row)" icon="el-icon-edit" v-permissions="['business:company:update']">编辑</el-button>
                        <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:company:delete']">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
        </template>
        <!-- 新建/修改 -->
        <OperaProblemsWindow ref="operaProblemsWindow" @success="handlePageChange"/>
    </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaProblemsWindow from '@/components/business/OperaProblemsWindow'
export default {
  name: 'Problems',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaProblemsWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        title: '',
        useType: ''
      }
    }
  },
  created () {
    this.config({
      module: '试题信息表',
      api: '/business/problems',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    edit (row) {
      if (row.objectList && row.objectList.length > 0) {
        row.objectList = row.objectList.map((item, index) => {
          return {
            code: item.code,
            value: item.value,
            sort: '选项' + item.code,
            id: index.toString()
          }
        })
      } else {
        row.objectList = []
      }
      if (row.type === 2) {
        row.answer = row.answer.split(',')
      }
      this.$refs.operaProblemsWindow.open('编辑试题信息', row)
    }
  }
}
</script>
